import { m } from '../../mithril';
import type { MithrilVNode } from '../../mithril';
import { addStyles } from '../theme';
import { Input } from './input';
import { CSS, Style } from './LocationField.input.style';

import { Translate } from '../../i18n';
import { Services } from '../../services';
import { DistanceInput } from './distance.input';
import { DistanceInputState } from './distance.input.state';
import { LocationFieldInputState } from './LocationField.input.state';

addStyles(Style);

export const LocationFieldInput = {
	view(state: LocationFieldInputState | DistanceInputState): MithrilVNode {
		if (state instanceof LocationFieldInputState) {
			return m('tr', { className: CSS.row }, [
				m('td', { className: CSS.label }, Translate(state.label)),
				m('td', { className: CSS.inputs }, [Input.view(state)]),
				state.hasError() ? m('td', { className: CSS.MDL.error + ' ' + CSS.error }, Translate(state.error)) : null,
			]);
		} else if (state instanceof DistanceInputState) {
			return m('tr', { className: CSS.row }, [
				m('td', { className: CSS.label }, Translate(state.label)),
				m('td', { className: CSS.inputs }, [DistanceInput.view(state, Services.UserSettings.units)]),
				state.hasError() ? m('td', { className: CSS.MDL.error + ' ' + CSS.error }, Translate(state.error)) : null,
			]);
		}
		return null;
	},
};
